import { jsx as _jsx } from "react/jsx-runtime";
import { LightBulbIcon } from '@heroicons/react/24/outline';
export var InitiativeAndOwnershipIcon = function (_a) {
    var _b = _a.className, className = _b === void 0 ? 'w-5 h-5 inline-block' : _b;
    return _jsx(LightBulbIcon, { className: className });
};
export default InitiativeAndOwnershipIcon;
